var _g, _g2, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 18,
    height: 16,
    viewBox: "0 0 138.7 116.8",
    fill: "currentColor",
    style: {
      enableBackground: "new 0 0 138.7 116.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000072264769247619866890000004875859559851123594_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.77,0.43H17.43L0.26,23.06v17.17c0,4.76,3.87,8.64,8.64,8.64s8.64-3.87,8.64-8.64c0,4.76,3.87,8.64,8.64,8.64l0,0 c4.76,0,8.64-3.87,8.64-8.64l0,0c0,4.76,3.87,8.64,8.64,8.64s8.64-3.87,8.64-8.64c0,4.76,3.87,8.64,8.64,8.64 c4.76,0,8.64-3.87,8.64-8.64c0,4.76,3.87,8.64,8.64,8.64l0,0c4.76,0,8.64-3.87,8.64-8.64l0,0c0,4.76,3.87,8.64,8.64,8.64 s8.64-3.87,8.64-8.64c0,4.76,3.87,8.64,8.64,8.64c4.76,0,8.64-3.87,8.64-8.64c0,4.76,3.87,8.64,8.64,8.64l0,0 c4.76,0,8.64-3.87,8.64-8.64l0,0V23.06L120.77,0.43H107.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.71,99.99V51.65H9.49v48.34c0,9.03,7.35,16.38,16.38,16.38h61.85V69.22h24.62v47.05 C121.37,116.37,128.71,109.03,128.71,99.99z M73.72,100.89H24.18V61.78h49.54V100.89z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 77.17,
    transform: "matrix(0.6154 -0.7882 0.7882 0.6154 -44.7464 63.9401)",
    width: 10.3,
    height: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.87,
    y: 80.78,
    transform: "matrix(0.5909 -0.8068 0.8068 0.5909 -46.1486 71.8525)",
    width: 23.8,
    height: 1.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 47.43,
    y: 84.4,
    transform: "matrix(0.5596 -0.8287 0.8287 0.5596 -47.3051 81.0735)",
    width: 10.4,
    height: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/Store.8a67621ae21e306b11440baa046582f4.svg";
export { ForwardRef as ReactComponent };